import { render, staticRenderFns } from "./WorkHoursPayItemMappingGrid.vue?vue&type=template&id=2106a4f2"
import script from "./WorkHoursPayItemMappingGrid.vue?vue&type=script&lang=js"
export * from "./WorkHoursPayItemMappingGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports